/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { LspCustomerReturnProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const lspCustomerReturnProcessFetchLspCustomerReturnProcessLoading = (
  state,
  { boolean }
) => ({
  ...state,
  processIsLoading: boolean
});

export const lspCustomerReturnProcessFetchLspCustomerReturnProcessSuccess = (
  state,
  { process }
) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LspCustomerReturnProcessTypes.LSP_CUSTOMER_RETURN_PROCESS_FETCH_LSP_CUSTOMER_RETURN_PROCESS_LOADING]: lspCustomerReturnProcessFetchLspCustomerReturnProcessLoading,
  [LspCustomerReturnProcessTypes.LSP_CUSTOMER_RETURN_PROCESS_FETCH_LSP_CUSTOMER_RETURN_PROCESS_SUCCESS]: lspCustomerReturnProcessFetchLspCustomerReturnProcessSuccess
});
